import * as OffersApiService from '../services/api/requests/Offers'

// get all offers
export const doGetAllOffers = ({
  accessToken,
  setNewOffers = () => {},
  onSuccess = () => {},
  onError = () => {},
}) => async limit => {
  await OffersApiService.getAllOffers(accessToken, limit)
    .then(response => {
      setNewOffers(response.data)
      onSuccess(response)
    })
    .catch(error => {
      onError(error)
    })
}

// get all rewards merchants
export const doGetAllRewardsMerchants = ({
  accessToken,
  setRewards = () => {},
  onSuccess = () => {},
  onError = () => {},
}) => async limit => {
  OffersApiService.getAllRewardsMerchants(accessToken)
    .then(response => {
      const responseData = Array.from(response.data.slice(0, limit))
      setRewards(responseData.reverse())
      onSuccess(response)
    })
    .catch(error => {
      onError(error)
    })
}

// get all rewards merchants
export const doGetRewardsMerchants = ({
  accessToken,
  selectedCatalogId,
  setRewards = () => {},
  onSuccess = () => {},
  onError = () => {},
}) => async (limit, id) => {
  await OffersApiService.getRewardsMerchants({ accessToken, catalogId: id })
    .then(response => {
      if (selectedCatalogId === id) {
        const responseData = Array.from(response.data.slice(0, limit))
        setRewards(responseData.reverse())
      }

      onSuccess(response)
    })
    .catch(error => {
      onError(error)
    })
}

// activates an offer
export const doActivateOffer = ({
  accessToken,
  push,
  baseUrl,
  onSuccess = () => {},
  onError = () => {},
}) => async id => {
  try {
    await OffersApiService.activateOffer(id, accessToken)

    if (push) {
      push(baseUrl)
    }
    onSuccess()
  } catch (error) {
    onError(error)
  }
}

// get offer data
export const doGetOffer = ({
  accessToken,
  setOfferModalData,
  onSuccess = () => {},
  onError = () => {},
}) => async viewId => {
  try {
    const response = await OffersApiService.getOffer(viewId, accessToken)
    setOfferModalData(response.data)
    onSuccess()
  } catch (error) {
    onError(error)
  }
}

// gets rewards by merchant
export const doGetRewardsByMerchant = ({
  accessToken,
  setRewardModalData,
  onSuccess = () => {},
  onError = () => {},
}) => async viewId => {
  try {
    const response = await OffersApiService.getRewardsByMerchant(
      viewId,
      accessToken,
    )
    setRewardModalData(response.data)
    onSuccess()
  } catch (error) {
    onError(error)
  }
}

// get all rewards
export const doGetAllRewards = ({
  accessToken,
  setRewards,
  onSuccess = () => {},
  onError = () => {},
}) => async (limit = '', catalogId) => {
  await OffersApiService.getAllRewards(accessToken, limit, catalogId)
    .then(response => {
      setRewards(response.data)
      onSuccess(response)
    })
    .catch(error => {
      onError(error)
    })
}
